import React, {useContext, useState} from "react";
import Web3 from "web3";
import {
  createWalletProvider,
  getAccounts,
  switchNetwork,
} from "./wallectConnectUtility";
import { connectorLocalStorageKey, walletLocalStorageKey } from "./Config";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  setAccount,
  setMetamask,
  setNetworkId,
} from "../../features/counter/proposalSlice";
import { hexToNumber } from "../../Common/cultDaoFunctions";
import { AuthContext } from "../../App";
import { network } from "../../Common/config";
export const MoreWalletCard = ({ ...props }) => {
  return (
    <button {...props}>
      <p fontSize="14px">More</p>
    </button>
  );
};

const WalletCard = ({ walletConfig, setShowModal }) => {
  const [toasts, setToasts] = useState([]);
  const { title, icon: Icon } = walletConfig;
  const { setWeb3Instance } = useContext(AuthContext);

  const notify = (Message) => toast(Message);

  const dispatch = useDispatch();

  const connectWallet = async () => {
    const arr = ["trust wallet", "walletconnect", "safepal wallet"];
    // Since iOS does not support Trust Wallet we fall back to WalletConnect
    // removed the && isIOS for now
    if (arr.includes(walletConfig?.title?.toLocaleLowerCase())) {
      const provider = await createWalletProvider(walletConfig.title);
      if (provider?.wc?._peerMeta?.name !== "SafePal Wallet")
        await switchNetwork(provider);
      const instance = new Web3(provider);
      if (provider?.accounts[0]) {
        setWeb3Instance(instance);
        localStorage.setItem("account", provider?.accounts[0]);
        dispatch(setAccount(provider?.accounts[0]));
        localStorage.setItem(walletLocalStorageKey, walletConfig.title);
        localStorage.setItem(
          connectorLocalStorageKey,
          walletConfig.connectorId
        );
      }
      const chainId = provider?.chainId;
      localStorage.setItem("chainId", hexToNumber(chainId, instance));
      dispatch(setNetworkId(localStorage.getItem("chainId")));
      dispatch(setMetamask(true));
      provider?.on("accountsChanged", (accounts) => {
        localStorage.setItem("account", accounts[0]);
        dispatch(setAccount(accounts[0]));
      });
      provider?.on("chainChanged", (chainId) => {
        if (hexToNumber(chainId, instance) !== network) {
          notify("Wrong Network");
          localStorage.setItem("chainId", hexToNumber(chainId, instance));
          dispatch(setNetworkId(localStorage.getItem("chainId")));
        } else {
          localStorage.setItem("chainId", hexToNumber(chainId, instance));
          dispatch(setNetworkId(localStorage.getItem("chainId")));
        }
      });
    } else {
      
      const browserProvider = await createWalletProvider();
      console.log('browserProvider', browserProvider);
      await switchNetwork(browserProvider);
      const browserInstance = new Web3(browserProvider);
      if (browserInstance) {
        setWeb3Instance(browserInstance);
        const response = await browserInstance?.eth.requestAccounts();
        if (response) {
          const account = await getAccounts();
          localStorage.setItem("account", account[0]);
          dispatch(setAccount(account[0]));
          localStorage.setItem(walletLocalStorageKey, walletConfig.title);
          localStorage.setItem(
            connectorLocalStorageKey,
            walletConfig.connectorId
          );
          const chainId = await browserInstance?.eth?.getChainId();
          localStorage.setItem(
            "chainId",
            hexToNumber(chainId, browserInstance)
          );
          dispatch(setNetworkId(localStorage.getItem("chainId")));
          dispatch(setMetamask(true));
        }
      } else {
        dispatch(setMetamask(false));
        dispatch(setAccount(""));
        setWeb3Instance("");
        handleClick("Please install Metamask");
      }
    }
    setShowModal(false);
  };

  const handleClick = (description = "") => {
    const now = Date.now();
    const randomToast = {
      id: `id-${now}`,
      description,
    };
    setToasts((prevToasts) => [randomToast, ...prevToasts]);
  };

  const handleRemove = (id) => {
    setToasts((prevToasts) =>
      prevToasts.filter((prevToast) => prevToast.id !== id)
    );
  };

  return (
    <>
      <button
        type="button"
        onClick={() => connectWallet()}
        id={`wallet-connect-${title?.toLocaleLowerCase()}`}
        className="text-gray-900 bg-gray-100 w-full hover:bg-gray-200 hover:shadow focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-sm text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-500 group"
      >
        <div className="sm:block hidden">
          <Icon width="40px" ml="100px" mb="8px" />
        </div>
        <div className="sm:hidden block">
          <Icon width="24px" ml="100px" mb="4px" />
        </div>
        <span className="flex-1 ml-3 font-bold font-Nixie text-left sm:text-base text-sm whitespace-nowrap">
          {title}
        </span>
        {title === "Metamask" ? (
          <span className="inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs text-gray-700 bg-gray-200 rounded dark:bg-gray-700 dark:text-gray-400 font-Nixie font-bold group-hover:bg-white">
            Popular
          </span>
        ) : null}
      </button>
      <ToastContainer toasts={toasts} onRemove={handleRemove} />
    </>
  );
};

export default WalletCard;
